<template>
    <div class="post-img">
        <img v-if="!isGallery" :src="pictures.main ? (`${VUE_APP_SERVER_ROOT}picture/` + pictures.main) : '/img/404Picture.png'" alt="">
        <video v-if="needToBoldVideo" controls>
            <source :src="`${VUE_APP_SERVER_ROOT}video/` + video" type="video/mp4">
        </video>

        <div class="breadcrumpb" v-if="!isGallery || needToBoldVideo">
            <span @click.prevent="remVideo()" v-if="needToBoldVideo && auth ? auth.news.delete : false" style="font-size: 14px; font-weight: bold; color: #8a5f2e; float: left; cursor: pointer">حذف &times;</span>
        </div>

        <h3 v-text="kicker" class="kicker"></h3>
        <h2>
            {{ mainHeadline }}
            <span class="badge text-bg-danger position-absolute" v-if="vin" style="font-size: x-small!important;">{{ t('visitNews.vin') }}</span>
            <span :class="['badge', 'text-bg-primary', (isGallery && vin) ? '' : 'position-absolute']" v-if="isGallery" style="font-size: x-small!important;">{{ t('visitNews.galleryNews') }}</span>
        </h2>
        <h3 v-text="deck"></h3>
        <div class="post-img-data">
            <img src="@/assets/calandar-icon.png" alt="">
            <!-- <h3>نوشته شده در {{ createdTime }} مورخ {{ createdDate }}</h3> -->
            <h3>{{ t('timeString', { time: createdTime, date: createdDate }) }}</h3>
            <router-link :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/edit/${$route.params.newID}/${mainHeadline.replaceAll(' ', '-')}`" class="btn btn-green" style="margin-right: 1rem;" v-if="auth ? (auth.news.edit && auth.news.levelOfAccess.filter(n => n.description == topic).length) : false">{{ t('edit') }}</router-link>
            <router-link :to="`#`" @click="deleteNew" class="btn btn-brown" style="margin-right: .6rem;" v-if="auth ? (auth.news.delete && auth.news.levelOfAccess.filter(n => n.description == topic).length) : false">{{ t('delete') }}</router-link>
        </div>
    </div>

    <div class="post-content">
        <div class="meta-description">
            <p v-text="lead" :data-summary="t('visitNews.summary')"></p>
        </div>
        <div v-html="parseContentToHTML" v-if="!isGallery"></div>
    </div>
</template>

<script>

import { useAuth } from '@/authentication'
import $ from 'jquery'
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

export default {
    name: "ParseWYSIWYG",
    components: {},
    mixins: [],
    props: ["kicker", "mainHeadline", "deck", "lead", "content", "createdDate", "createdTime", "pictures", "vin", "id", "video", "topic", "isGallery", "needToBoldVideo"],
    data: () => ({
        auth: useAuth(),
        VUE_APP_SERVER_ROOT: process.env.VUE_APP_SERVER_ROOT,
        t: useI18n().t,
        $route: useRoute()
    }),
    methods: {
        remGalleryPicture(pictureName) {
            if (confirm("آیا مطمئنید می‌خواهید این تصویر را حذف کنید؟")) $.ajax({
                url: `${process.env.VUE_APP_SERVER_ROOT}delete-picture`,
                method: "POST",
                data: { pictureName },
                xhrFields: {
                    withCredentials: true
                },
                dataType: "json",
                success(data) {
                    if (data.STATUS) {
                        alert("حذف شد")
                        location.reload()
                    } else {
                        alert(`حذف موفقیت آمیز نبود؛ ${data.REASON}`)
                    }
                },
                error() {
                    alert("ارسال درخواست موفقیت آمیز نبود")
                }
            })
        },
        addGalleryPicture() {
            const fileInp = document.createElement('INPUT')
            fileInp.setAttribute("type", "file")
            fileInp.setAttribute("accept", "image/png,.jpeg,.jpg")
            fileInp.setAttribute("multiple", true)
            $(fileInp).change(e => {
                const fd = new FormData
                // fd.append("files", fileInp.files)
                Array.from(fileInp.files).forEach((file, i) => {
                    fd.append("files[" + i + "]", file)
                })
                fd.append("newID", this.id)
                $.ajax({
                    url: `${process.env.VUE_APP_SERVER_ROOT}new-gallery-picture`,
                    method: "POST",
                    data: fd,
                    xhrFields: { withCredentials: true },
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success(data) {
                        if (data.STATUS) {
                            alert('ذخیره شد')
                            location.reload()
                        } else {
                            alert(data.REASON)
                        }
                    }, 
                    error() {
                        alert('ارسال اطلاعات ممکن نبود')
                    }
                })
            })
            $(fileInp).click()
        },
        checkExpressionStyles(expr) {
            const insert = expr.insert, attribs = expr.attributes ?? {}

            var classList = [],
                tag = "span",
                additionalAttributes = []
            
            if (attribs.bold) classList[classList.length] = "bold"
            if (attribs.italic) classList[classList.length] = "italic"

            if (attribs.link) {
                tag = "a"
                additionalAttributes[additionalAttributes.length] = `href="${attribs.link}"`
            }

            return `<${tag} class="${classList.join(" ")}" ${additionalAttributes.join(" ")}>${insert}</${tag}>`
        },
        gotoPicture($event) {
            if ($event.target.nodeName == 'BUTTON') return false;
            const picture = $event.target.getAttribute('src')
            // open(picture, '_blank')
        },
        deleteNew() {
            if (confirm("مطمئنید می‌خواهید این خبر را حذف کنید؟")) {
                const vueApp = this;
                $.ajax({
                    url: `${process.env.VUE_APP_SERVER_ROOT}delete-new`,
                    method: "POST",
                    data: { newID: this.$route.params.newID },
                    xhrFields: {
                        withCredentials: true
                    },
                    dataType: "json",
                    success(data) {
                        if (data.STATUS) {
                            alert("حذف شد")
                            vueApp.$router.push(vueApp.$route.params.locale ? `/${vueApp.$route.params.locale}/news` : '/news')
                        } else {
                            alert(`حذف موفقیت آمیز نبود؛ ${data.REASON}`)
                        }
                    },
                    error() {
                        alert("ارسال درخواست موفقیت آمیز نبود")
                    }
                })
            }
        },
        remVideo() {
            if (confirm("آیا مطمئنید می‌خواهید فیلم خبر را حذف کنید؟")) $.ajax({
                url: `${process.env.VUE_APP_SERVER_ROOT}delete-video`,
                method: "POST",
                data: { newID: this.$route.params.newID },
                xhrFields: {
                    withCredentials: true
                },
                dataType: "json",
                success(data) {
                    if (data.STATUS) {
                        alert("حذف شد")
                        location.reload()
                    } else {
                        alert(`حذف موفقیت آمیز نبود؛ ${data.REASON}`)
                    }
                },
                error() {
                    alert("ارسال درخواست موفقیت آمیز نبود")
                }
            })
        }
    },
    computed: {
        parseContentToHTML: {
            // get() {
            //     const content = this.content;
            //     var now = "";
            //     var result = "";
            //     var listStatus = false;
            //     for (const key in content) {
            //         if (Object.hasOwnProperty.call(content, key)) {
            //             const item = content[key];
            //             const insert = item.insert;
            //             const attributes = item.attributes ?? {};
            //             if (insert != "\n") {
            //                 var classList = "";
            //                 var tag = "span";
            //                 var additionalAttributes = ""
            //                 if (attributes.bold) {
            //                     classList += " bold";
            //                 }
            //                 if (attributes.italic) {
            //                     classList += " italic"
            //                 }
            //                 if (attributes.link) {
            //                     tag = "a"
            //                     additionalAttributes += ` href="${attributes.link}"`
            //                 }
            //                 now += `<${tag} class="${classList}"${additionalAttributes}>${insert}</${tag}>`
            //             } else {
            //                 if (!listStatus) {
            //                     if (attributes.header) {
            //                         result += `<h${attributes.header}>${now}</h${attributes.header}>`
            //                     } else if (attributes.list) {
            //                         listStatus = attributes.list
            //                         if (attributes.list == "ordered") {
            //                             result += "<ol>"
            //                         }
            //                         else if (attributes.list == "bullet") {
            //                             result += "<ul>"
            //                         }
            //                         result += `<li>${now}</li>`
            //                     } else {
            //                         result += now + "\n"
            //                     }
            //                 } else {
            //                     if (!attributes.list) {
            //                         if (listStatus == "ordered") {
            //                             result += `</ol>${now}\n`
            //                         } else if (listStatus == "bullet") {
            //                             result += `</ul>${now}\n`
            //                         }
            //                         listStatus = false
            //                     } else {
            //                         result += `<li>${now}</li>`
            //                     }
            //                 }
                            
            //                 now = ""
            //             }
            //         }
            //     }
            //     return result
            // }
            get() {
                const config = {}
                const converter = new QuillDeltaToHtmlConverter(this.content, config)

                return converter.convert();

                // var result = ""
                // var oneLine = "%{0}"
                // var onList = false

                // for (const key in content) {
                //     if (Object.hasOwnProperty.call(content, key)) {
                //         const 
                //             item = content[key],
                //             insert = item.insert,
                //             attribs = item.attributes ?? {}

                //         if (insert == "\n") {
                //             if (!onList) {
                //                 if (attribs.list) {
                //                     onList = attribs.list
                //                     result += `<${onList == 'bullet' ? 'ul' : "ol"}>`
                //                 } else {
                //                     // Nothing To Do
                //                 }
                //             } else {
                //                 if (attribs.list) {
                //                     if (attribs.list == onList) {
                //                         // Nothing To Do
                //                     } else {
                //                         result += `</${onList == 'bullet' ? 'ul' : "ol"}>`
                //                         onList = attribs.list
                //                         result += `<${onList == 'bullet' ? 'ul' : "ol"}>`
                //                     }
                //                 } else {
                //                     result += `</${onList == 'bullet' ? 'ul' : "ol"}>`
                //                     onList = false
                //                 }
                //             }
                //         }

                //         if (!insert.hasOwnProperty("image")) {
                //             var splitByNewLineChar = insert.split("\n"),
                //             tag = "p"

                //             if (Object.getOwnPropertyNames(content).indexOf(key) == 0 && onList) {
                //                 tag = "li"
                //             } 

                //             if (splitByNewLineChar.length > 1) {
                //                 const newLine = "%{0}" + splitByNewLineChar.pop()
                //                 oneLine += splitByNewLineChar.join("\n") + "%{1}"
                                
                //                 if (attribs.header) {
                //                     tag = `h${attribs.header}`
                //                 }
                //                 if (onList) {
                //                     tag = 'li'
                //                 }

                //                 result += oneLine.format(`<${tag}>`, `</${tag}>`)

                //                 oneLine = newLine
                //             } else {
                //                 oneLine += this.checkExpressionStyles(item)
                //             }

                //         } else {
                //             result += "<img src='" + insert.image + "' class='inter-text-img' />"
                //         }

                //     }
                // }

                // return result
                
            }
        },
        shortURL: {
            get() {
                return /^https?\:\/\/([0-9.:a-zA-Z]+)\/visit\/(\d+)/.exec(location.href)[0]
            }
        }
    }
}

</script>

<style lang="less">

.bold {
    font-weight: bold;
}

.italic {
    font-style: italic;
}

::marker {
    font-family: B Lotus;
    font-size: 120%;
}

.inter-text-img {
    max-width: 100%;
}

.rem-gallery:hover {
    background-color: #9008!important;
}

.btn-green {
    --bs-btn-color: #fff !important;
    --bs-btn-bg: #209f89 !important;
    --bs-btn-border-color: #209f89 !important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #27b9a0;
    --bs-btn-hover-border-color: #27b9a0;
    --bs-btn-focus-shadow-rgb: 217, 164, 6;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #27b9a0;
    --bs-btn-active-border-color: #27b9a0;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #209f89 !important;
    --bs-btn-disabled-border-color: #209f89 !important;
}

.btn-brown {
    --bs-btn-color: #fff !important;
    --bs-btn-bg: #8a5f2e !important;
    --bs-btn-border-color: #8a5f2e !important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #a16f36;
    --bs-btn-hover-border-color: #a16f36;
    --bs-btn-focus-shadow-rgb: 217, 164, 6;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #a16f36;
    --bs-btn-active-border-color: #a16f36;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #8a5f2e !important;
    --bs-btn-disabled-border-color: #8a5f2e !important;
}

</style>

<style scoped lang="less">
    
    .post-img>h3 {
        font-size: 150%;
        color: #566;
        margin-right: 20px;

        &.kicker {
            margin-top: 14px;
        }
    }


</style>